import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=ac79e6a4&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=ac79e6a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac79e6a4",
  null
  
)

export default component.exports